<ion-header class="header" mode="md">
  
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title class="ion-text-center header-title">{{ 'TERMS.TITLE' | translate }}</ion-title>

      <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/']" replaceUrl class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>

       <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>

</ion-header>

<ion-content>

   <ion-grid fixed class="ion-padding">
    <ion-row>
      <ion-col class="info">
        <app-terms-sl *ngIf="'sl' == translateService.currentLang"></app-terms-sl>
        <app-terms-en *ngIf="'sl' !== translateService.currentLang"></app-terms-en>
      </ion-col>

    </ion-row>
  </ion-grid>
 
</ion-content>